import { lazy } from "react";

import { RouteProps } from "react-router-dom";

import CookiePolicy from "pages/CookiePolicy";
import Main from "pages/Main";
import ForInfluencers from "pages/ForInfluencers";
import WaxWallet from "pages/WaxWallet";

const OurProcess = lazy(() => import("pages/OurProcess"));
const TermsOfUse = lazy(() => import("pages/TermsOfUse"));
const PrivacyPolicy = lazy(() => import("pages/PrivacyPolicy"));
const ContactUs = lazy(() => import("pages/ContactUs"));
const GameRules = lazy(() => import("pages/GameRules"));
const BuyNft = lazy(() => import("pages/BuyNft"));

export enum RouteUrls {
  ROOT_URL = "/",
  OUR_PROCESS_URL = "/our-process",
  BLOG_URL = "/blog",
  CONTACT_US_URL = "/contact-us",
  COOKIE_POLICY_URL = "/cookie-policy",
  PRIVACY_POLICY_URL = "/privacy-policy",
  TERMS_OF_USE_URL = "/terms-of-use",
  GAME_RULES_URL = "/game-rules",
  BUY_NFT_URL = "/buy-nft",
  FOR_INFLUENCERS_URL = "/for-influencers",
  WAX_WALLET_URL = "/how-to-create-wax-cloud-wallet-free-activation"
}

export const routes: RouteProps[] = [
  {
    component: Main,
    path: RouteUrls.ROOT_URL,
    exact: true,
  },
  {
    component: CookiePolicy,
    path: RouteUrls.COOKIE_POLICY_URL,
    exact: true,
  },
  {
    component: ContactUs,
    path: RouteUrls.CONTACT_US_URL,
    exact: true,
  },
  {
    component: PrivacyPolicy,
    path: RouteUrls.PRIVACY_POLICY_URL,
    exact: true,
  },
  {
    component: TermsOfUse,
    path: RouteUrls.TERMS_OF_USE_URL,
    exact: true,
  },
  {
    component: OurProcess,
    path: RouteUrls.OUR_PROCESS_URL,
    exact: true,
  },
  {
    component: GameRules,
    path: RouteUrls.GAME_RULES_URL,
    exact: true,
  },
  {
    component: BuyNft,
    path: RouteUrls.BUY_NFT_URL,
    exact: true,
  },
  {
    component: ForInfluencers,
    path: RouteUrls.FOR_INFLUENCERS_URL,
    exact: true,
  },
  {
    component: WaxWallet,
    path: RouteUrls.WAX_WALLET_URL,
    exact: true,
  }
];
